// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"264b5653","703":"acd0a2bc","787":"46f4c8e0"}[chunkId] + ".chunk.js";
};